import { createClient } from '@supabase/supabase-js';

// Supabase credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl ? '✓' : '✗');
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✓' : '✗');
}

// Create Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
